import { AgGridColumnProps } from "ag-grid-react/lib/agGridColumn";
import { asTimelessDate } from "lqx-react/lib";

const asOption = (params) => params.value.name

export const RemittanceAdviceInvoiceTableColumns: AgGridColumnProps[] = [
    {
        headerName: "Invoice Number",
        field: "number",
        checkboxSelection: true
    },
    {
        headerName: "Supplier",
        field: "supplier",
        cellEditor: "SupplierMultiSelectDropdownEditor",
        valueFormatter: asOption
    },
    {
        headerName: "Buyer",
        field: "buyer",
        cellEditor: "BuyerMultiSelectDropdownEditor",
        valueFormatter: asOption
    },
    {
        headerName: "Invoice Date",
        field: "invoiceDate",
        cellEditor: "DateEditor",
        valueFormatter: asTimelessDate
    },
    {
        headerName: "Invoice Due Date",
        field: "invoiceDueDate",
        cellEditor: "DateEditor",
        valueFormatter: asTimelessDate
    },
    {
        headerName: "Face Value",
        field: "faceValue",
        cellEditor: "NumberWithDecimalEditor"
    },
    {
        headerName: "Currency",
        field: "currency",
        cellEditor: 'SelectCurrencyEditor'
    },
    {
        headerName: "Discount",
        field: "discount",
        cellEditor: "NumberWithDecimalEditor"
    },
    {
        headerName: "Net Amount",
        field: "netAmount",
        cellEditor: "NumberWithDecimalEditor"
    },
    {
        headerName: "Applied Amount",
        field: "appliedAmount",
        cellEditor: "NumberWithDecimalEditor"
    },
    {
        headerName: "Write Off",
        field: "writeOff",
        cellEditor: "NumberWithDecimalEditor"
    },
    {
        headerName: "Details",
        field: "details"
    }
]
